/** tab section */
var tabTriggerLi = document.querySelectorAll('.tabs li');

tabTriggerLi.forEach(function(tabTriggerLi, index){
    tabTriggerLi.addEventListener('click', function(){
        var currentTabData = document.querySelector('.tab-content[data-tab-content="' + this.dataset.tabTrigger + '"]');

        // remove classess
        document.querySelector('.tab-content.is-open').classList.remove('is-open');
        document.querySelector('.tabs li.is-active').classList.remove('is-active');
        // add classes
        currentTabData.classList.add('is-open');
        this.classList.add('is-active');

    });
});

/**mobile tab */

+(function ($) {
  $(function(){


    $('ul.tabs').on('click',function(){

      if($(this).hasClass('open')){
        $(this).removeClass('open');

      }else{
        $(this).addClass('open');
      }

    });

/** mobileview for mediaquery */
    if($(window).width()<1200){
      $("body").addClass("mobileview");
    } 
    else {
      $("body").removeClass("mobileview");
    }
    // this is used whenever the window is resized
    $(window).resize(function(){
    if($(window).width()<1200){
          $("body").addClass("mobileview");
      } 
      else {
          $("body").removeClass("mobileview");
      }
    });


    /** image equipe on hover */
    $("document").ready(function(){ 

      /**jonathan */
      $('.jonathan img').hover(function(){
        $(this).attr('src','/wp-content/themes/planitou/assets/images/jonathan-fun-img.png').fadeTo(1000,0.8);
        $(this).removeAttr('srcset');
 
      },function(){
        $(this).attr('src','/wp-content/themes/planitou/assets/images/jonathan-img.png').fadeTo(2000,1);

      });

      /**pierre */
      $('.pierre img').hover(function(){
        $(this).attr('src','/wp-content/themes/planitou/assets/images/pierre-fun-img.png').fadeTo(1000,0.8);
        $(this).removeAttr('srcset');
        
      },function(){
        $(this).attr('src','/wp-content/themes/planitou/assets/images/pierre-img.png').fadeTo(2000,1);
       
      });
      /**Sabrina */
      $('.sabrina img').hover(function(){
        $(this).attr('src','/wp-content/themes/planitou/assets/images/sabrina-fun-img.png').fadeTo(1000,0.8);
        $(this).removeAttr('srcset');
        
      },function(){
        $(this).attr('src','/wp-content/themes/planitou/assets/images/sabrina-img.png').fadeTo(2000,1);
       
      });
      /**Francois */
      $('.francois img').hover(function(){
        $(this).attr('src','/wp-content/themes/planitou/assets/images/francois-fun-img.png').fadeTo(1000,0.8);
        $(this).removeAttr('srcset');
        
      },function(){
        $(this).attr('src','/wp-content/themes/planitou/assets/images/francois-img.png').fadeTo(2000,1);
       
      });
      /**Isamel */
      $('.ismael img').hover(function(){
        $(this).attr('src','/wp-content/themes/planitou/assets/images/ismael-fun-img.png').fadeTo(1000,0.8);
        $(this).removeAttr('srcset');
        
      },function(){
        $(this).attr('src','/wp-content/themes/planitou/assets/images/ismael-img.png').fadeTo(2000,1);
        
      });


    });

//page webinaire filter******************************************************
      //overide js exitsant pour le dropdown select
      var dropdown = document.getElementById("wp-block-categories-1");
      function onCatChange(e) {
        if ( dropdown.options[dropdown.selectedIndex].value > 0 ) {
          location.href = "#!";
          e.preventDefault()
        }
      }
      if (dropdown) {
        dropdown.onchange = onCatChange;
      }
      
    //hide and show selon categorie id 
  
        $('#wp-block-categories-1').on('change', function(e){
          e.preventDefault()
          var IDvalue = $(this).val(); 
          $("li.wp-block-post").hide();
          $(".cat-"+IDvalue+"-id").show();
            if (IDvalue == -1 || IDvalue == 1 || IDvalue == 10){
              $("li.wp-block-post").show();
            }
            
        });
      
  });
})(jQuery);


//compte à rebours page osez
if(document.getElementById("compteRebours")) {

  var deadline = new Date("April 5, 2023 15:37:25").getTime();
  var x = setInterval(function() {
  var now = new Date().getTime();
  var t = deadline - now;
  var days = Math.floor(t / (1000 * 60 * 60 * 24));
  var hours = Math.floor((t%(1000 * 60 * 60 * 24))/(1000 * 60 * 60));
  var minutes = Math.floor((t % (1000 * 60 * 60)) / (1000 * 60));
  var seconds = Math.floor((t % (1000 * 60)) / 1000);
  let textDay = '';
  let textHeure = '';
  let textMinute = '';
  let textSeconde = '';
  if(days > 1){
    textDay = ' Jours '
  }else if(days <= 1){
    textHeure = ' jour '
  }
  if(hours > 1){
    textHeure = ' Heures '
  }else if(hours <= 1){
    textHeure = ' heure '
  }
  if(minutes > 1){
    textMinute = ' Minutes '
  }else if(minutes <= 1){
    textMinute = ' Minute '
  }
  if(seconds > 1){
    textSeconde = ' Secondes '
  }else if(seconds <= 1){
    textSeconde = ' Seconde '
  }
  
  document.getElementById("compteRebours").innerHTML = 
  '<div class="cd-box">' +
    '<div class="numbers days">'+ days + '</div>' 
    +'<div class="strings timeRefDays">' + textDay +  '</div>'
  +'</div>'
  +'<div class="cd-box">' 
    +'<div class="numbers hours">'+ hours + '</div>' 
    + '<div class="strings timeRefHours">' + textHeure + '</div>' 
  + '</div>' 
  + '<div class="cd-box">' 
    + '<div class="numbers minutes">' + minutes + '</div>' 
    + '<div class="strings timeRefMinutes">' + textMinute + '</div>' 
  + '</div>'+ 
  '<div class="cd-box">' 
    + '<div class="numbers seconds">' + seconds + '</div>' 
    + '<div class="strings timeRefSeconds">' + textSeconde + '</div>' 
  +  '</div>' ;
      if (t < 0) {
          clearInterval(x);
          document.getElementById("compteRebours").innerHTML = "OSEZ MAINTENANT";
      }
    },1000);

  
  
}


    